import React from "react";
import "../assets/css/Footer.css";
import logo from "../assets/images/main-logo.png";

import linkedin from "../assets/icons/mdi_linkedin.png";
import instagram from "../assets/icons/ri_instagram-fill.png";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row gy-4">

          {/* COL 1 : LOGO + ABOUT */}
          <div className="col-md-3">
            <img src={logo} alt="Auto Assure Logo" className="footer-logo" />

            <p className="footer-text">
              {t("footer.aboutText")}
            </p>

            <div className="footer-social">
              <span>{t("footer.follow")}</span>
              <div className="social-icons">
                <a
                  href="https://www.linkedin.com/in/auto-assure-09205239b"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <img src={linkedin} alt="LinkedIn" />
                </a>

                <a
                  href="https://www.instagram.com/auto_assure_"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <img src={instagram} alt="Instagram" />
                </a>
              </div>
            </div>
          </div>

          {/* COL 4 : LOCATIONS */}
        <div className="col-md-3 address-blk">
            <h5 className="footer-title">{t("footer.locations")}</h5>

            <p>
              <strong>{t("footer.uae")}</strong><br />
              {t("footer.uaeAddress")}
            </p>

            <p>
              <strong>{t("footer.india")}</strong><br />
              <Trans i18nKey="footer.indiaAddress" />
            </p>
          </div>

          {/* COL 3 : CONTACT */}
          <div className="col-md-2">
            <h5 className="footer-title">{t("footer.contact")}</h5>            
            
            {/* UAE */}
            <p>
              <strong>{t("footer.uae")}</strong><br />
              {t("footer.phoneLabel")}{" "}
              <a href="tel:+971554405896">
                {t("footer.uaePhone")}
              </a>
              <p>Mon-Sun: 09:00 - 18:30</p>
            </p>

            {/* INDIA */}
            <p>
              <strong>{t("footer.india")}</strong><br />
              {t("footer.phoneLabel")}{" "}
              <a href="tel:+917754925771">
                {t("footer.indiaPhone1")}
              </a>
              <br />
              {t("footer.phoneLabel")}{" "}
              <a href="tel:+918090555551">
                {t("footer.indiaPhone2")}
              </a>
              <p>Mon-Sun: 09:00 - 20:00</p>
            </p>
            

            {/* EMAIL (COMMON) */}
            <p>
              {t("footer.emailLabel")}{" "}
              <a href="mailto:info@autoassure360.com">
                {t("footer.email")}
              </a>
            </p>
          </div>


          {/* COL 2 : EXPLORE */}
          <div className="col-md-2">
            <h5 className="footer-title">{t("footer.explore")}</h5>
            <ul className="footer-links">
              <li>
                <Link to="/about">{t("nav.about")}</Link>
              </li>
              <li>
                <Link to="/contact">{t("nav.contact")}</Link>
              </li>
              <li>
                <Link to="/privacy-policy">{t("footer.privacy")}</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">{t("footer.terms")}</Link>
              </li>
            </ul>
          </div>

          {/* COL 5 : MAPS */}
          <div className="col-md-2 map-boxes">
            <div className="map-box">
              <p>
                <strong>{t("footer.mapLocationUAE")}</strong><br />  
              </p>
              <iframe
                src="https://www.google.com/maps?q=25.320682525634766,55.459171295166016&output=embed"
                width="100%"
                height="130"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="UAE Office Map"
              />
            </div>


            <div className="map-box mt-3">
              <p>
                <strong>{t("footer.mapLocationIndia")}</strong><br />  
              </p>
              <iframe
                src="https://www.google.com/maps?q=26.89364242553711,81.07249450683594&output=embed"
                width="100%"
                height="130"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="India Office Map"
              />
            </div>
          </div>
        </div>

        {/* COPYRIGHT */}
        <div className="row footer-bottom">
          <div className="col text-center">
            © 2026 Auto Assure360 | {t("footer.rights")}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
